export const getAllRolePermissions = (rolesOrPermissions) => {
  if (!rolesOrPermissions) return []

  if (Array.isArray(rolesOrPermissions?.role)) {
    return getAllRolePermissions(rolesOrPermissions.role)
  }

  if (Array.isArray(rolesOrPermissions?.permissions)) {
    return rolesOrPermissions.permissions
  }

  if (rolesOrPermissions?.additional_info) {
    return rolesOrPermissions.additional_info ?? []
  }

  if (Array.isArray(rolesOrPermissions)) {
    return rolesOrPermissions.flatMap((item) => {
      if (item?.additional_info) return item.additional_info
      // Already a permission entry
      if (
        Object.prototype.hasOwnProperty.call(item ?? {}, 'permission_id') &&
        Object.prototype.hasOwnProperty.call(item ?? {}, 'section_id')
      ) {
        return [item]
      }
      return []
    })
  }

  return []
}

export const userHasPermission = (currentPermissions, toValidate = []) => {
  const allPermissions = getAllRolePermissions(currentPermissions)
  if (!allPermissions.length || !toValidate?.length) return undefined

  const isAnyPermissionValid = toValidate.some(
    ({ specie, section, permission, actionType }) => {
      if (!specie || !section || !permission || !actionType?.length) {
        console.warn('Hubo un problema validando los permisos')
        return false
      }

      const expectedActions = actionType.map((type) => Number(type))

      const hasPermission = allPermissions.some((p) => {
        const permissionTypes = Array.isArray(p.permission_type_id)
          ? p.permission_type_id.map((type) => Number(type))
          : []

        return (
          Number(p.pyramid_specie_id) === Number(specie) &&
          Number(p.section_id) === Number(section) &&
          Number(p.permission_id) === Number(permission) &&
          permissionTypes.some((typeId) => expectedActions.includes(typeId))
        )
      })

      return hasPermission
    }
  )

  return isAnyPermissionValid
}
